exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes animatedgradient{}.messages--pagination{margin-bottom:15px;display:flex;justify-content:flex-end}", ""]);

